// apps/client/src/ui/kit/Pill.tsx
import type { ReactNode } from 'react';
export function Pill(p: { icon?: ReactNode; children: ReactNode }) {
  return <span className="pill">{p.icon}{p.children}</span>;
}
